import {Observable, Subscription} from 'rxjs';

import ErrorType      from '../../../../Shared/Constants/ErrorType';
import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToConsumerError = (
    consumerError$: Observable<ErrorType>,
    playbackStore: IPlaybackStore
): Subscription =>
    consumerError$
        .subscribe((errorType: ErrorType) => playbackStore.actions.error(errorType));

export default subscribeToConsumerError;